import React from "react";
import { connect } from "react-redux";
import Dropzone from "react-dropzone";
import Button from '@material-ui/core/Button';
import { Link } from "react-router-dom";
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import * as agent from "../agent";
import { CLIENT_LOADED, UPLOAD_PROGRESS, MESSAGE_SENDED } from "../constants/actionTypes";
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';

const file = ({id, carId, onUpload, onDelete, name, desc, title, client, upload}) => {
    // eslint-disable-next-line eqeqeq
    const {docs = {}} = client.cars.find(car => car._id == carId);
    const doc = docs[name];
    const uploadPercent = upload[name] || 0;
    let dropzoneRef;
    return (
        <div className="file-container">
            <Typography align="center" paragraph>{desc}</Typography>
            <Dropzone ref={(node) => { dropzoneRef = node; }}
                      className="hidden-dropzone"
                      onDrop={(files) => onUpload(id, carId, name, files)} />
            <Button size="medium"
                    disabled={uploadPercent > 0 && uploadPercent < 100}
                    fullWidth
                    color="primary"
                    onClick={() => { dropzoneRef.open() }}
                    variant="contained" >
                {uploadPercent > 0 && uploadPercent < 100 ? `Загрузка: ${Math.round(uploadPercent)}%` : "Загрузить файл"}
            </Button>
            {doc.length > 0 &&
                <List classes={{ root: "image-list" }}>
                    {doc.map(({ contenttype, id, thumb }, i) => {
                        const thumbUrl = agent.src.thumb(thumb);
                        const icon = contenttype.startsWith("image") ? thumbUrl : contenttype.endsWith("pdf")? "/images/icons/pdf.png" : "/images/icons/doc.png"
                        return (
                            <ListItem disableGutters divider >
                                <Link target="_blank" to={agent.src.doc(id)}>
                                    <img className="gallery-thumb" src={icon} alt="" />
                                </Link>
                                <ListItemSecondaryAction>
                                    <IconButton size="medium" onClick={(ev) => {ev.preventDefault(); onDelete(client._id, carId, id);}}>
                                      <DeleteIcon  />
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </ListItem>
                        )}
                    )}
                </List>
            }
        </div>
    );
};

export default connect(
    state => ({
        ...state.client,
        upload: state.common.upload,

    }),
    dispatch => ({
        onUpload: (id, carId, name, files) =>
            agent.Client.uploadDoc(
                id,
                carId,
                name,
                files,
                ev => dispatch({type: UPLOAD_PROGRESS, payload: {name, percent: ev.percent}})
            )
            .then(client => dispatch({type: CLIENT_LOADED, payload: client}))
            .catch(e => dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } })),
        onDelete: (id, carId, doc) =>
            agent.Client.deleteDoc(id, carId, doc)
            .then(client => dispatch({type: CLIENT_LOADED, payload: client}))
            .catch(e => alert(e)),
    })
)(file);



// WEBPACK FOOTER //
// ./src/components/File.js